export default __webpack_public_path__ + "static/media/modal7.499f0650.png";